export interface BeforeInstallPromptChoice {
  outcome: 'accepted' | 'dismissed';
  platform: string;
}

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<BeforeInstallPromptChoice>;
  prompt: () => Promise<void>;
}

export function isBeforeInstallPromptEvent(event: Event): event is BeforeInstallPromptEvent {
  return 'prompt' in event && typeof (event as BeforeInstallPromptEvent).prompt === 'function';
}

export function isAppInstalled(): boolean {
  return isStandaloneDisplayMode() || isIosStandaloneMode();
}

function isStandaloneDisplayMode(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches;
}

function isIosStandaloneMode(): boolean {
  return Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
}
